const RENTAL_REQUEST_SOURCES = {
  REDFIN_API: 'redfin_api',
  REDFIN: 'Redfin',
  APPARTMENTS: 'Apartments.com',
  CRAIGSLIST: 'craigslist',
};

export default RENTAL_REQUEST_SOURCES;
